var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49992 0.333008C2.91992 0.333008 0.833252 2.41967 0.833252 4.99967C0.833252 8.49967 5.49992 13.6663 5.49992 13.6663C5.49992 13.6663 10.1666 8.49967 10.1666 4.99967C10.1666 2.41967 8.07992 0.333008 5.49992 0.333008ZM5.49992 6.66634C4.57992 6.66634 3.83325 5.91967 3.83325 4.99967C3.83325 4.07967 4.57992 3.33301 5.49992 3.33301C6.41992 3.33301 7.16658 4.07967 7.16658 4.99967C7.16658 5.91967 6.41992 6.66634 5.49992 6.66634Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.073886ff0f46f79cfab8d1f2bd4461d6.svg";
export { ForwardRef as ReactComponent };